import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { BaasEdgePoolsAndClustersPayload } from '~src/settings/dataconnect-settings/sections/types/BaasEdgePoolsAndClustersPayload';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IGetBaasEdgePoolsAndClustersParams {
  siteId: string;
}

export interface IGetBaasEdgePoolsAndClustersResult extends IResult {
  success?: BaasEdgePoolsAndClustersPayload;
  error?: BaasEdgePoolError;
}

export class GetBaasEdgePoolsRequest extends Request<IGetBaasEdgePoolsAndClustersParams, IGetBaasEdgePoolsAndClustersResult> {
  constructor(params: IGetBaasEdgePoolsAndClustersParams) {
    super('getBaasEdgePoolsAndClusters', params);
  }
}
